import { FC } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@features/ui';

interface ConfirmDeleteGroupPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  groupTitle?: string;
}

export const ConfirmDeleteGroupPopup: FC<ConfirmDeleteGroupPopupProps> = ({
  open,
  onOpenChange,
  onConfirm,
  groupTitle,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[500px] max-w-[90vw] mx-auto">
        <DialogHeader className="mb-5">
          <DialogTitle className="text-2xl text-center mb-[23px]">
            Delete User Group
          </DialogTitle>
          <DialogDescription className="text-white text-[16px] text-center">
            Are you sure you want to delete{' '}
            {groupTitle ? `"${groupTitle}"` : 'this user group'}? This action
            cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <div className="flex items-center justify-center gap-10">
            <Button
              className="w-20"
              size="sm"
              variant="destructive"
              onClick={() => {
                onConfirm();
                onOpenChange(false);
              }}
            >
              Delete
            </Button>
            <Button
              className="w-20"
              size="sm"
              variant="secondary"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
